import React from 'react';

const SmileIcon = (props) => {
    return (
        <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
             height={props.height ? props.height : '24'} viewBox="0 0 24 24" fill="none"
             stroke={props.stroke ? props.stroke : 'currentColor'}
             strokeWidth={props.strokeWidth ? props.strokeWidth : '2'} strokeLinecap="round"
             strokeLinejoin="round"
        >
            <circle cx="12" cy="12" r="10"/>
            <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
            <line x1="9" x2="9.01" y1="9" y2="9"/>
            <line x1="15" x2="15.01" y1="9" y2="9"/>
        </svg>
    );
};

export default SmileIcon;


// WEBPACK FOOTER //
// ./src/assets/icons/SmileIcon.jsx